import { render, staticRenderFns } from "./vigencias-sni.vue?vue&type=template&id=00f56dce&"
import script from "./vigencias-sni.component.ts?vue&type=script&lang=ts&"
export * from "./vigencias-sni.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports